// extracted by mini-css-extract-plugin
module.exports = {"balance-color":"balance-color-3b202f494cc878d495639f9c89e5266d","balance-text":"balance-text-ebf056b4d734608b7b2c3054dcaf65a5"};